import { Base, withBreakpointObserver } from '@studiometa/js-toolkit';
import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';

/**
 * Slider component
 */
export default class Gallery extends withBreakpointObserver(Base) {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Gallery',
    refs: ['slider', 'prev', 'next', 'pagination'],
  };

  /**
   *
   */
  mounted() {
    this.slider = new Swiper(this.$refs.slider, {
      modules: [Pagination],
      slidesPerView: 'auto',
      grabCursor: true,
      pagination: {
        el: this.$refs.pagination,
      },
    });
  }
}
